import './CallsTermsModal.scss';
import { ToastType } from 'modules/application/misc/ToastService';
import { blipCallsTermsOfUseUrl } from 'app.constants';
export class CallsTermsModalController {
    static $inject = ['AccountService2', 'TenantService', 'SegmentService', 'BlipToastService', '$translate', 'close'];
    constructor(AccountService2, TenantService, SegmentService, BlipToastService, $translate, close) {
        'ngInject';
        this.AccountService2 = AccountService2;
        this.TenantService = TenantService;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.close = close;
        this.acceptedTerms = false;
        this.isSaving = false;
        this.onChangeCheckBox = async (event) => {
            this.acceptedTerms = await event.detail.checked;
            this.SegmentService.createTrack('blipcalls-user-checked-terms', { 'checked': this.acceptedTerms });
        };
        this.openTermsLink = () => {
            this.SegmentService.createTrack('blipcalls-open-terms-file');
            window.open(blipCallsTermsOfUseUrl, '_blank');
        };
        this.save = async () => {
            this.isSaving = true;
            const currentUser = (await this.AccountService2.me()).identity;
            const tenantId = this.TenantService.getTenantPrefixFromUrl();
            const result = await this.TenantService.saveCallsTerms(tenantId, blipCallsTermsOfUseUrl, currentUser);
            this.isSaving = false;
            this.SegmentService.createTrack('blipcalls-user-accept-terms');
            if (result.status != 'success') {
                console.error('Error saving terms acceptance');
                await this.showToast('callsTermsModal.toast.error', ToastType.Danger);
                return;
            }
            await this.showToast('callsTermsModal.toast.success', ToastType.Success);
            this.close(true);
        };
    }
    async $onInit() {
        document
            .getElementById('checkbox-terms')
            .addEventListener('bdsChange', this.onChangeCheckBox);
    }
    async showToast(messageReference, type) {
        const msg = await this.$translate(messageReference);
        const toastOptions = { msg };
        await this.BlipToastService.show(type, toastOptions);
    }
}
CallsTermsModalController.$inject = ['AccountService2', 'TenantService', 'SegmentService', 'BlipToastService', '$translate', 'close'];
